export default __webpack_public_path__ + "static/media/paymentCheckout.0910238a.png";